import React, { Fragment, useContext, useEffect, useState } from 'react';
import "./oneProject.css";
import { visitedContext } from './visitedContext.js';
import { MouseHoverContext } from './mousHoverContext.js';
import { useNavigate, useParams } from 'react-router-dom';

export default function OneProject({ snap, setSnap, setBackgroundPosition }) {
    const [showImage, setShowImage] = useState(0);
    const { visitedPage, setVisitedPage } = useContext(visitedContext);
    const { mousehover, setMouseHover } = useContext(MouseHoverContext);
    const [vanish, setVanish] = useState(false);
    const navigate = useNavigate();
    const { categoryID } = useParams();

    console.log("Component Rendered");

    // First-time visit logic
    useEffect(() => {
        if (!visitedPage.projects) {
            console.log("Running first-visit projects...");
            setVisitedPage((prev) => ({ ...prev, projects: true }));
        } else {
            console.log("Running return projects...");
        }
    }, [visitedPage, setVisitedPage]);

    useEffect(() => {
        setSnap(true);
        setVanish(false);
    }, [setSnap]);

    // Intersection Observer Logic
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        console.log("Animating element...");
                        entry.target.classList.add("glitch-anim-1");
                        observer.unobserve(entry.target); // Stop observing after the animation starts
                    }
                });
            },
            {
                threshold: 0.6, // Trigger when 60% of the element is visible
            }
        );

        // Select elements to observe AFTER the DOM updates
        const hiddenElements = document.querySelectorAll(".sub-pic2");

        // Observe each element
        hiddenElements.forEach((el) => observer.observe(el));

        // Cleanup observer on unmount
        return () => observer.disconnect();
    }, []); // Empty dependency array ensures this runs once on mount

    const anotherPage = (url) => {
        setVanish(true);
        setTimeout(() => {
            setBackgroundPosition(12);
            navigate(url);
        }, 600);
    };

    return (
        <Fragment>
            <div className="project-gallery">
                <img
                    className={vanish ? "main-pic disapearFromTopProjects1" : "main-pic"}
                    src={require(`../src/pics/${showImage}.png`)}
                    alt=""
                />
            </div>
            <div className="buttons">
                <button className="button-49" role="button">Live Demo</button>
                <button className="button-49" role="button">Github Code</button>
            </div>
            <div className="container-oneProject">
                <div className={vanish ? "work-list disapearFromTopProjects1" : "work-list"}>
                    <div className="title">Online Shop</div>
                    <div className="options">
                        <div className="text">
                            <div className="name">Category</div>
                            <div className="decriptions">Branding UX/UI Design Web Development</div>
                        </div>
                        <div className="line"></div>
                        <div className="exp">
                            Sharlee is the nickname I use on social medias. The goal of this project was to create my own identity, adaptable and modular to work with both my real name and my nickname. First, the identity needed to be defined in brand guidelines and then had to be adapted for digital medias (website, wallpapers, social medias) and physical formats (business cards/stickers, letter paper and resume).
                        </div>
                    </div>
                </div>
                <div className="group-pic">
                    <img className={vanish ? "sub-pic disapearFromTopProjects1" : "sub-pic"} src={require(`../src/pics/14.jpg`)} alt="" />
                    <img className="sub-pic2" src={require(`../src/pics/14.jpg`)} alt="" />
                </div>
                <div className="group-pic">
                    <img className={vanish ? "sub-pic disapearFromTopProjects1" : "sub-pic"} src={require(`../src/pics/13.jpg`)} alt="" />
                    <img className="sub-pic2" src={require(`../src/pics/13.jpg`)} alt="" />
                </div>
                <div className="line2"></div>
                <div className="list" onMouseEnter={() => { setShowImage(1); setMouseHover(true); }} onMouseLeave={() => { setShowImage(0); setMouseHover(false); }} onClick={() => anotherPage("/OneProject/1/onlineShop")}>
                    <img className="arrow" src={require("../src/pics/left-arrow.png")} alt="" />
                    <div className="text">
                        <div className="name">Next Project</div>
                        <div className="decriptions">Web Development</div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
